import React, { useEffect } from "react";
import { FaDownload } from "@react-icons/all-files/fa/FaDownload";
import { FaFilePdf } from "@react-icons/all-files/fa/FaFilePdf";
import { FaCalendarAlt } from "@react-icons/all-files/fa/FaCalendarAlt";
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import { FaMapMarkerAlt } from "@react-icons/all-files/fa/FaMapMarkerAlt";
import { FaPhoneAlt } from "@react-icons/all-files/fa/FaPhoneAlt";
import { FaEnvelope } from "@react-icons/all-files/fa/FaEnvelope";
import { FaExclamationTriangle } from "@react-icons/all-files/fa/FaExclamationTriangle";
import { FaExternalLinkAlt } from "@react-icons/all-files/fa/FaExternalLinkAlt";
import HeaderBanner from "../../components/HeaderBanner";

import lkctcNotice from "../../assets/pdf/pg-ahs-2026/LKCTC_PG_AHS_Exam_Notice_2026.pdf";
import ptuNotice from "../../assets/pdf/pg-ahs-2026/IKGPTU_PG_AHS_Notice_2026.pdf";
import studentInstructions from "../../assets/pdf/pg-ahs-2026/Instructions_Entrance_Exam_Students_2026.pdf";
import examFormPdf from "../../assets/pdf/pg-ahs-2026/PG_AHS_Entrance_Examination_Form_2026.pdf";
import pgAHSResult from "../../assets/pdf/pg-ahs-2026/Entrance_Examination_Result_PG_AHS_2026_27.pdf";

const PGAHSEntranceExam = () => {
  useEffect(() => {
    document.title = "PG AHS Entrance Examination 2026–27 | LKCTC";
    window.scrollTo(0, 0);
  }, []);

  const downloadDocuments = [
    {
      id: "result-pdf",
      title: "Entrance Examination Result 2026–27 (Official)",
      description:
        "Official declared result for M.Sc Medical Laboratory Science, Microbiology, Anaesthesia & OTT, and Radiology & Imaging Technology (Session 2026-27).",
      type: "PDF",
      icon: <FaFilePdf className="text-red-600 text-3xl flex-shrink-0" />,
      link:
        pgAHSResult ||
        "/docs/pg-ahs-2026/Entrance_Examination_Result_PG_AHS_2026_27.pdf",
      downloadName: "Entrance_Examination_Result_PG_AHS_2026_27.pdf",
      badgeColor: "bg-emerald-100 text-emerald-800 border-emerald-300",
      primary: true,
    },
    {
      id: "form-pdf",
      title: "Entrance Examination Application Form",
      description:
        "Official printable application form for admission in PG Allied and Healthcare courses.",
      type: "PDF",
      icon: <FaFilePdf className="text-red-600 text-3xl flex-shrink-0" />,
      link:
        examFormPdf ||
        "/docs/pg-ahs-2026/PG_AHS_Entrance_Examination_Form_2026.pdf",
      downloadName: "PG_AHS_Entrance_Examination_Form_2026.pdf",
      badgeColor: "bg-red-100 text-red-800 border-red-200",
      primary: true,
    },
    {
      id: "lkctc-notice",
      title: "LKCTC Official Notice (Ref No: 8076/21.09.2026)",
      description:
        "Institution notice on examination schedule, timings, and form submission email.",
      type: "PDF",
      icon: <FaFilePdf className="text-red-600 text-3xl flex-shrink-0" />,
      link:
        lkctcNotice || "/docs/pg-ahs-2026/LKCTC_PG_AHS_Exam_Notice_2026.pdf",
      downloadName: "LKCTC_PG_AHS_Exam_Notice_2026.pdf",
      badgeColor: "bg-red-100 text-red-800 border-red-200",
      primary: false,
    },
    {
      id: "student-instructions",
      title: "Instructions for Students (Guidelines & Rules)",
      description:
        "Official instructions, syllabus mapping, question format, and conduct guidelines.",
      type: "PDF",
      icon: <FaFilePdf className="text-red-600 text-3xl flex-shrink-0" />,
      link:
        studentInstructions ||
        "/docs/pg-ahs-2026/Instructions_Entrance_Exam_Students_2026.pdf",
      downloadName: "Instructions_Entrance_Exam_Students_2026.pdf",
      badgeColor: "bg-red-100 text-red-800 border-red-200",
      primary: false,
    },
    {
      id: "ptu-notice",
      title: "IKGPTU Notification (Ref No: IKGPTU/DA/2375)",
      description:
        "Official university notification regarding conduct of PG AHS entrance examination.",
      type: "PDF",
      icon: <FaFilePdf className="text-red-600 text-3xl flex-shrink-0" />,
      link: ptuNotice || "/docs/pg-ahs-2026/IKGPTU_PG_AHS_Notice_2026.pdf",
      downloadName: "IKGPTU_PG_AHS_Notice_2026.pdf",
      badgeColor: "bg-red-100 text-red-800 border-red-200",
      primary: false,
    },
  ];

  const scheduleData = [
    {
      particulars: "Date of Examination",
      details: "23.09.2026 (Wednesday)",
      highlight: true,
    },
    {
      particulars: "Document Verification Time at College",
      details: "09:00 AM",
      highlight: false,
    },
    {
      particulars: "Reporting Time at Examination Centre",
      details: "10:30 AM",
      highlight: false,
    },
    {
      particulars: "Examination Start Time",
      details: "11:00 AM",
      highlight: true,
    },
    {
      particulars: "Duration of Examination",
      details: "90 Minutes (1 Hour 30 Minutes)",
      highlight: false,
    },

    {
      particulars: "Examination Centre",
      details:
        "Lyallpur Khalsa College Technical Campus (LKCTC), Cantt. Road, Near Bus Stand, Jalandhar",
      highlight: false,
    },
  ];

  return (
    <div className="bg-[#f8f9fa] min-h-screen">
      {/* Header Banner */}
      <div>
        <HeaderBanner
          bgImage="AboutBanner"
          title="PG AHS Entrance Examination 2026–27"
          currentPage="PG AHS Entrance Exam 2026–27"
        />
        <div className="bannerBotttom h-[3.5rem] w-full"></div>
      </div>

      {/* Main Container */}
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-20">
        {/* Title Section */}
        <div
          id="examination"
          className="mt-8 mb-6 flex justify-center text-center"
        >
          <h1 className="border-l-4 border-[#32727A] pl-4 text-2xl md:text-4xl font-extrabold text-[#081C3A]">
            PG Allied & Healthcare Sciences Entrance Examination 2026–27
            <span className="block text-lg md:text-xl font-medium text-[#32727A] mt-1">
              Conducted by I.K. Gujral Punjab Technical University at LKCTC
              Examination Centre
            </span>
          </h1>
        </div>

        {/* RESULTS DECLARED BANNER */}
        <div className="bg-gradient-to-r from-[#081C3A] via-[#103463] to-[#14532d] text-white p-6 sm:p-8 rounded-2xl shadow-xl mb-10 border-2 border-emerald-400">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 bg-emerald-400 text-[#081C3A] text-xs md:text-sm font-extrabold px-3 py-1 rounded-full uppercase tracking-wider">
                🎉 Results Declared (23.09.2026)
              </div>
              <h2 className="text-xl sm:text-2xl font-bold text-white">
                Entrance Examination Result 2026–27 Published
              </h2>
              <p className="text-sm sm:text-base text-gray-200 leading-relaxed max-w-3xl">
                The entrance examination result for Postgraduate Allied and
                Healthcare Courses (M.Sc MLS, Medical Microbiology, Anaesthesia &
                OTT, Radiology & Imaging Technology) held on 23rd September 2026
                has been officially announced by the Controller of Examination.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row md:flex-col gap-3 w-full md:w-auto flex-shrink-0">
              <a
                href={
                  pgAHSResult ||
                  "/docs/pg-ahs-2026/Entrance_Examination_Result_PG_AHS_2026_27.pdf"
                }
                download="Entrance_Examination_Result_PG_AHS_2026_27.pdf"
                className="inline-flex items-center justify-center gap-2 bg-emerald-400 hover:bg-emerald-300 text-[#081C3A] font-extrabold px-6 py-3 rounded-xl shadow-lg transition-all text-sm sm:text-base text-center"
              >
                <FaDownload /> Download Result (PDF)
              </a>
              <a
                href={
                  pgAHSResult ||
                  "/docs/pg-ahs-2026/Entrance_Examination_Result_PG_AHS_2026_27.pdf"
                }
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-100 text-[#081C3A] font-bold px-6 py-3 rounded-xl shadow-lg transition-all text-sm sm:text-base text-center border border-gray-200"
              >
                <FaFilePdf className="text-red-600" /> View Result (PDF)
              </a>
            </div>
          </div>
        </div>

        {/* URGENT NOTICE / ACTION BANNER */}
        <div className="bg-gradient-to-r from-[#081C3A] via-[#103463] to-[#32727A] text-white p-6 sm:p-8 rounded-2xl shadow-xl mb-10 border-2 border-yellow-400">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 bg-yellow-400 text-[#081C3A] text-xs md:text-sm font-extrabold px-3 py-1 rounded-full uppercase tracking-wider">
                <FaExclamationTriangle className="text-sm" /> Urgent
                Announcement & Registration
              </div>
              <h2 className="text-xl sm:text-2xl font-bold text-white">
                Exam Date: Wednesday, 23rd September 2026
              </h2>
              <p className="text-sm sm:text-base text-gray-200 leading-relaxed">
                All candidates are required to download, fill out the Entrance
                Examination Application Form, and email the scanned copy to{" "}
                <a
                  href="mailto:pankajkumar@lkcengg.edu.in"
                  className="text-yellow-300 font-bold underline hover:text-yellow-200"
                >
                  pankajkumar@lkcengg.edu.in
                </a>{" "}
                on or before{" "}
                <span className="text-yellow-300 font-bold">
                  21.09.2026 by 3:00 PM
                </span>
                .
              </p>
              <div className="text-xs text-gray-300 pt-1">
                Admit cards can be collected from the College Principal’s office
                on or before 22.09.2026.
              </div>
            </div>

            <div className="flex flex-col sm:flex-row md:flex-col gap-3 w-full md:w-auto flex-shrink-0">
              <a
                href={
                  examFormPdf ||
                  "/docs/pg-ahs-2026/PG_AHS_Entrance_Examination_Form_2026.pdf"
                }
                download="PG_AHS_Entrance_Examination_Form_2026.pdf"
                className="inline-flex items-center justify-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-[#081C3A] font-extrabold px-6 py-3 rounded-xl shadow-lg transition-all text-sm sm:text-base text-center"
              >
                <FaDownload /> Download Application Form
              </a>
              <a
                href={
                  examFormPdf ||
                  "/docs/pg-ahs-2026/PG_AHS_Entrance_Examination_Form_2026.pdf"
                }
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-100 text-[#081C3A] font-bold px-6 py-3 rounded-xl shadow-lg transition-all text-sm sm:text-base text-center border border-gray-200"
              >
                <FaFilePdf className="text-red-600" /> View Form (PDF)
              </a>
            </div>
          </div>
        </div>

        {/* SECTION 1: DOWNLOADABLE DOCUMENTS */}
        <div className="mb-12">
          <div className="primary-bg-color p-3.5 rounded-xl text-white text-xl font-bold shadow-md flex items-center justify-between mb-6">
            <span>📥 Official Notifications & Downloadable Documents</span>
            <span className="text-xs bg-white/20 px-3 py-1 rounded-full uppercase tracking-wider font-semibold">
              {downloadDocuments.length} Documents
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {downloadDocuments.map((doc) => (
              <div
                key={doc.id}
                className={`bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 flex flex-col justify-between border ${
                  doc.primary
                    ? "border-[#32727A] ring-2 ring-[#32727A]/20"
                    : "border-gray-200"
                }`}
              >
                <div>
                  <div className="flex items-start justify-between gap-3 mb-4">
                    <div className="p-3 bg-gray-50 rounded-xl border border-gray-100">
                      {doc.icon}
                    </div>
                    <span
                      className={`text-xs font-bold px-2.5 py-1 rounded-full border uppercase tracking-wider ${doc.badgeColor}`}
                    >
                      {doc.type}
                    </span>
                  </div>

                  <h3 className="text-lg font-bold text-[#081C3A] leading-snug mb-2 hover:text-[#32727a] transition-colors">
                    {doc.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                    {doc.description}
                  </p>
                </div>

                <div className="flex gap-2 pt-4 border-t border-gray-100">
                  <a
                    href={doc.link}
                    download={doc.downloadName}
                    className="flex-1 inline-flex items-center justify-center gap-2 primary-bg-color hover:bg-[#32727a] text-white text-sm font-semibold py-2.5 px-4 rounded-lg shadow-sm transition-all"
                  >
                    <FaDownload className="text-xs" /> Download
                  </a>
                  {doc.type === "PDF" && (
                    <a
                      href={doc.link}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center justify-center gap-1.5 bg-gray-100 hover:bg-gray-200 text-[#081C3A] text-sm font-semibold py-2.5 px-3 rounded-lg transition-all"
                      title="Open in new tab"
                    >
                      <FaExternalLinkAlt className="text-xs" />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* SECTION 2: EXAMINATION SCHEDULE */}
        <div className="mb-12">
          <div className="primary-bg-color p-3.5 rounded-xl text-white text-xl font-bold shadow-md mb-6">
            📅 Examination Schedule & Centre Details
          </div>

          <div className="bg-white rounded-2xl shadow-md border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-[#081C3A] text-white">
                    <th className="py-4 px-6 text-sm font-bold uppercase tracking-wider w-1/3">
                      Particulars
                    </th>
                    <th className="py-4 px-6 text-sm font-bold uppercase tracking-wider">
                      Details & Schedule
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 text-gray-800">
                  {scheduleData.map((row, idx) => (
                    <tr
                      key={idx}
                      className={`hover:bg-gray-50 transition-colors ${
                        row.highlight ? "bg-amber-50/70 font-semibold" : ""
                      }`}
                    >
                      <td className="py-3.5 px-6 font-medium text-[#081C3A] flex items-center gap-2">
                        {row.particulars.includes("Date") && (
                          <FaCalendarAlt className="text-[#32727A]" />
                        )}
                        {row.particulars.includes("Time") && (
                          <FaClock className="text-[#32727A]" />
                        )}
                        {row.particulars.includes("Centre") && (
                          <FaMapMarkerAlt className="text-[#32727A]" />
                        )}
                        {row.particulars}
                      </td>
                      <td className="py-3.5 px-6">
                        {row.highlight ? (
                          <span className="text-[#081C3A] font-bold">
                            {row.details}
                          </span>
                        ) : (
                          row.details
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* SECTION 3: CONTACT & HELPDESK */}
        <div>
          <div className="primary-bg-color p-3.5 rounded-xl text-white text-xl font-bold shadow-md mb-6">
            ☎️ Helpdesk & Contact Information
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-[#32727A]/10 text-[#32727A] flex items-center justify-center text-xl mb-3">
                <FaPhoneAlt />
              </div>
              <h4 className="font-bold text-[#081C3A] mb-1">
                Mr. Pankaj Kumar
              </h4>
              <p className="text-xs text-gray-500 mb-3">
                Examination Superintendent
              </p>
              <a
                href="tel:7009403066"
                className="inline-block primary-bg-color hover:bg-[#32727a] text-white text-sm font-semibold px-4 py-2 rounded-lg transition-all"
              >
                +91-7009403066
              </a>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-blue-50 text-blue-600 flex items-center justify-center text-xl mb-3">
                <FaEnvelope />
              </div>
              <h4 className="font-bold text-[#081C3A] mb-1">
                Application Submission
              </h4>
              <p className="text-xs text-gray-500 mb-3">
                Email scanned copies by 3 PM (21.09.2026)
              </p>
              <a
                href="mailto:pankajkumar@lkcengg.edu.in"
                className="inline-block bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-all"
              >
                pankajkumar@lkcengg.edu.in
              </a>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-md border border-gray-200 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-yellow-50 text-yellow-600 flex items-center justify-center text-xl mb-3">
                <FaPhoneAlt />
              </div>
              <h4 className="font-bold text-[#081C3A] mb-1">
                Admissions Helpline
              </h4>
              <p className="text-xs text-gray-500 mb-3">
                Toll-Free / Direct Admission Cell
              </p>
              <a
                href="tel:+918847262500"
                className="inline-block bg-yellow-400 hover:bg-yellow-300 text-[#081C3A] text-sm font-extrabold px-4 py-2 rounded-lg transition-all"
              >
                +91-88472-62500
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PGAHSEntranceExam;
